import template from './surveys_setup_questions_add.html';
import tr from '../../lib/default-translator.js';

class SurveySetupQuestionsAddViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.surveys = ko.observableArray();
		this.survey_items = ko.observableArray();
		this.survey_input_types = ko.observableArray();
		this.survey_items_options = ko.observableArray();
		this.survey_items_range = ko.observableArray();
		this.survey_id = ko.observable(0);
		this.options_check_value = ko.observable();
		this.options_radio_value = ko.observable();
	}

	close()
	{
		this.dialog.close();
	}
}

class SurveySetupQuestionsAddPage
{
	constructor (bindings)
	{
		this.viewModel = new SurveySetupQuestionsAddViewModel(this);
		this.bindings = bindings;

		this.viewModel.options_check_value.subscribe((newText) => {
			this.viewModel.options_check_value(newText);
		});

		this.viewModel.options_radio_value.subscribe((newText) => {
			this.viewModel.options_radio_value(newText);
		});
	}

	async init()
	{
		// SURVEY INPUT TYPES
		let inputtypes = await Grape.fetches.getJSON('/api/record', {
			table: 'survey_input_types',
			limit: 1000000
		});
		
		if (inputtypes)
			this.viewModel.survey_input_types(inputtypes.records);

		if (typeof this.bindings.data.survey_id === 'undefined')
		{
			this.viewModel.surveys([
				{
					'survey_id': 0,
					'title': '',
					'sub_title': '',
					'content': '',
					'start_date': moment().format('YYYY-MM-DD'),
					'end_date': moment().format('YYYY-MM-DD'), 'public': true 
				}
			]);
			
			this.viewModel.survey_items([
				{
					'survey_id': 0,
					'survey_items_id': 0,
					'question': '',
					'input_type': '',
					'description': '',
					'edit_name': false
				}
			]);

			this.viewModel.survey_id(0);
		}
		else
		{
			this.viewModel.survey_id(this.bindings.data.survey_id);
			this.updateData();
		}
	}

	async updateData()
	{
		// SURVEY ITEMS
		let items = await Grape.fetches.getJSON('/api/record', {
			table: 'v_survey_items',
			schema: 'savanna',
			limit: 1000000,
			sortfield: 'survey_items_id',
			sortorder: 'ASC',
			filter: [{
				value: this.bindings.data.survey_id,
				operand: '=',
				field: 'survey_id'
			}, {
				value: true,
				operand: '=',
				field: 'active'
			}]
		});
		
		if (items)
		{
			let surveys = items.records.map((x) => ({
				...x,
				edit_name: ko.observable(false)
			}));
			this.viewModel.survey_items(surveys);
		};
	}

	edit_question(v, e)
	{
		v.edit_name(true);
	}

	add_question(input_type)
	{
		let survey_item = {
			question: '',
			input_type: input_type,
			edit_name: ko.observable(true),
			survey_id: this.bindings.data.survey_id,
			survey_items_options: [],
			survey_items_range: [],
			active: true
		};

		this.viewModel.survey_items.unshift(survey_item);
	}	

	async add_check_option(v, e)
	{
		let data = {
			survey_items_id: v.survey_items_id,
			options: this.viewModel.options_check_value()
		};

		let url = '/surveys/save_survey_item_options';

		if (this.viewModel.options_check_value())
		{
			await this.save_new_option(url, data);
			this.viewModel.options_check_value('');
		}
		else
			Grape.alerts.alert({type: 'error', message: tr('Please enter check option', 'Please enter check option'), title: tr('Error', 'Error')});
	}

	async add_radio_option(v)
	{
		let data = {
			survey_items_id: v.survey_items_id,
			options: this.viewModel.options_radio_value()
		};

		let url = '/surveys/save_survey_item_options';

		if (this.viewModel.options_radio_value())
		{
			await this.save_new_option(url, data);
			this.viewModel.options_radio_value('');
		}
		else
			Grape.alerts.alert({type: 'error',message: tr('Please enter radio option', 'Please enter radio option'), title: tr('Error', 'Error')});
	}

	async save_question(data)
	{
		let question = ko.mapping.toJS(data);
		if (question.survey_id == '')
			question.survey_id = null;
		else
			question.survey_id = this.bindings.data.survey_id;

		let res = await Grape.fetches.postJSON('/surveys/save_survey_item', question);
		if (res)
		{
			if (res.status !== 'ERROR')
				this.updateData();
			else if (res.error)
			{
				Grape.alerts.apiError(res);
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	}

	async delete_question(v, e)
	{
		let data = ko.mapping.toJS(v);
		data.survey_id = this.bindings.data.survey_id;
		data.active = false;

		let res = await Grape.fetches.postJSON('/surveys/delete_survey_item', data);
		
		if (res)
		{
			if (res.status == 'OK')
				this.updateData();
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	}

	async save_option(v, e)
	{
		let data = ko.mapping.toJS(v);
		if (data.survey_items_id == 0)
			data.survey_items_id = null;

		let res = await Grape.fetches.postJSON('/surveys/save_survey_item_options', data);
		
		if (res)
		{
			if (res.status == 'OK')
				this.updateData()
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	}

	async delete_option(v, e)
	{
		let data = ko.mapping.toJS(v);

		let res = await Grape.fetches.postJSON('/surveys/delete_survey_item_options', data);
		
		if (res)
		{
			if (res.status == 'OK')
				this.updateData();
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	}

	async save_new_option(url, data)
	{
		let res = await Grape.fetches.postJSON(url, data);
		if (res)
		{
			if (res.status == 'OK')
				this.updateData();
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	}
}

export default {
	name: 'SurveySetupQuestionsAdd',
	dialog_class: SurveySetupQuestionsAddPage,
	template: template,
	template_filename: 'translation/dialogs/surveys_setup_questions_add',
	provider: 'ps'
};
